import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import Layout from '../Layout';
import GiftCardPage from '../pages/GiftCardPage';
import ExperiencePage from '../pages/ExperiencePage';
import LocationPage from '../pages/LocationPage';
import PersonalDetailsForm from '../components/PersonalDetailsForm';
import PaymentForm from '../components/PaymentForm';
import ShoppingCart from '../components/ShoppingCart';
import ConfirmationForm from '../components/ConfirmationForm';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';
import NavBar from '../audi-ui-components/NavBar';
import Alert from '../audi-ui-components/Alert';
import { scrollToTop } from '../lib/helpers';
import cookie from '../lib/cookie';

const mapStateToProps = (state) => {
    return {
        navBarActiveIndex: state.shoppingCart.navBarActiveIndex,
        disableNav: state.shoppingCart.disableNav,
        currentAlertStatus: state.shoppingCart.currentAlertStatus,
        alertMsg: state.shoppingCart.alertMsg,
        cart: state.shoppingCart.cart,
        cartId: state.shoppingCart.cart ? state.shoppingCart.cart.id : null,
        donation: state.shoppingCart.donation,
        heroTitle: state.shoppingCart.heroTitle,
        heroImage: state.shoppingCart.heroImage
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        fetchData: ACTIONS_CREATOR.fetchData,
        setShoppingCart: ACTIONS_CREATOR.setShoppingCart,
        setFinalCart: ACTIONS_CREATOR.setFinalCart,
        updateNavBarIndex: ACTIONS_CREATOR.updateNavBarIndex,
        setAlertMessage: ACTIONS_CREATOR.setAlertMessage,
    },
    dispatch,
  );

class ShoppingCartPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingCart: false
        }
    }

    componentDidMount() {
        // load cart
        this.setState({isLoadingCart: true});
        if (cookie.getItem("cartId")) {
            // fetch existing cart
            let cid = cookie.getItem("cartId");
            this.fetchCart(cid);
        } else {
            // create new cart
            this.createCart();
        }
        // set nav
        console.log("componentDidMount set nav");
        this.props.updateNavBarIndex(CONST.SHOPPING_NAV_INDEX);
    }

    fetchCart = (cid) => {
        // fetch existing cart
        this.props.fetchData(`/2/cart/${cid}`, "GET", "")
        .then(result => {
            if (!result || !result.id) {
                this.createCart();
            } else {
                this.props.setShoppingCart(result);
                this.setState({isLoadingCart: false});
            }
        })
        .catch(err => {
            if (err.status === 404) {
                this.createCart();
            } else {
                this.setState({isLoadingCart: false});
                err.then(errorMessage => {
                    this.props.setAlertMessage(true, 'danger', errorMessage.message);
                });
            }
        });
    }

    createCart = () => {
        // create new cart
        this.props.fetchData('/1/cart/create', 'POST', '')
        .then(result => {
            this.props.setShoppingCart(result);
            cookie.setItem("cartId", `${result.id}`, null, '/');
            this.setState({isLoadingCart: false});
        })
        .catch(err => {
            err.then(errorMessage => {
                this.props.setAlertMessage(true, 'danger', errorMessage.message);
            });
            this.setState({isLoadingCart: false});
        });
    }

    handleDetailsSubmit = () => {
        this.detailsForm.submitForm().then(() => {
          if (!this.detailsForm.isValid) {
            document.querySelector(".is-invalid").scrollIntoView();
          }
          return true;
        });
    }

    handlePaymentSubmit = () => {
        const {cart, cartId, donation} = this.props;
        if (cart.balanceAmount === 0 && (!donation || donation === 0)) {
            // cart amount is 0, no payment required
            this.props.setAlertMessage(true, 'success', 'Submitting your order...');
            this.props.fetchData(`/1/cart/${cartId}/order`, 'POST')
                .then((response) => {
                    this.props.setAlertMessage(false);
                    this.props.setFinalCart(response);
                    console.log("handlePaymentSubmit set nav");
                    this.props.updateNavBarIndex(CONST.CONFIRMATION_NAV_INDEX);
                })
                .catch(err => {
                  // console.log(err);
                  if (typeof err.then === 'function') {
                    err.then( errorMessage => {
                      // TODO: check (if modelState) to return more useful error messages
                      this.props.setAlertMessage(true, 'danger', errorMessage.message);
                    });
                  } else {
                    this.props.setAlertMessage(true, 'danger', "An error has occured");
                  }
                });
        } else {
            // submit payment form
            this.paymentForm.submitForm();
            scrollToTop();
        }
    }

    render() {
        const {disableNav, navBarActiveIndex, alertMsg, match, location} = this.props;
        const currentPath = location.pathname.split("/")[1];
        return (
            <Layout>
            <Helmet>
                <title>Shopping Cart | Audi Driving Experience</title>
            </Helmet>

            <div className="shopping-cart">

                <div style={{backgroundImage: `url(${this.props.heroImage})`}} className="heroContainer">
                    <div className="title">
                        <div className="inner-wrapper">
                            <h1 className="aui-headline-3">{this.props.heroTitle}</h1>
                        </div>
                    </div>
                </div>

                {(CONST.FEATURE_TOGGLE.MAINTENANCE || CONST.FEATURE_TOGGLE.MAINTENANCE_SF || CONST.FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE) && <div className="maintenance-note">
                    {!CONST.FEATURE_TOGGLE.MAINTENANCE && !CONST.FEATURE_TOGGLE.MAINTENANCE_SF && CONST.FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE && <div dangerouslySetInnerHTML={{__html: CONST.FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE}}></div>}
                    {(CONST.FEATURE_TOGGLE.MAINTENANCE || CONST.FEATURE_TOGGLE.MAINTENANCE_SF) && CONST.FEATURE_TOGGLE.MAINTENANCE_NOTE && <div dangerouslySetInnerHTML={{__html: CONST.FEATURE_TOGGLE.MAINTENANCE_NOTE}}></div>}
                </div>}

                {(!CONST.FEATURE_TOGGLE.MAINTENANCE && !CONST.FEATURE_TOGGLE.MAINTENANCE_SF) && <div className="inner-wrapper pt-5 pb-3">
                    <div className="mb-5">
                        <NavBar
                            actions={[
                                {text: 'Shopping cart', disabled: disableNav[CONST.SHOPPING_NAV_INDEX] || navBarActiveIndex === CONST.CONFIRMATION_NAV_INDEX},
                                {text: 'Personal details', disabled: disableNav[CONST.PERSONAL_NAV_INDEX] || navBarActiveIndex === CONST.CONFIRMATION_NAV_INDEX},
                                {text: 'Payment', disabled: disableNav[CONST.PAYMENT_NAV_INDEX] || navBarActiveIndex === CONST.CONFIRMATION_NAV_INDEX},
                                {text: 'Confirmation', disabled: disableNav[CONST.CONFIRMATION_NAV_INDEX]},
                            ]}
                            activeIndex={this.props.navBarActiveIndex}
                            onActionClick={this.props.updateNavBarIndex}
                        />
                    </div>

                    {this.props.cartId && !this.state.isLoadingCart && <div>
                        {navBarActiveIndex === CONST.SHOPPING_NAV_INDEX && match.params.amount && <GiftCardPage amount={match.params.amount} />}
                        {navBarActiveIndex === CONST.SHOPPING_NAV_INDEX && currentPath === CONST.PATH_COURSE && <ExperiencePage programSlug={match.params.programSlug} locationSlug={match.params.locationSlug} experienceId={match.params.experienceId} />}
                        {navBarActiveIndex === CONST.SHOPPING_NAV_INDEX && currentPath === CONST.PATH_LOCATION && <LocationPage programSlug={match.params.programSlug} locationSlug={match.params.locationSlug} />}
                        {navBarActiveIndex === CONST.PERSONAL_NAV_INDEX && <PersonalDetailsForm forwardedRef={(form) => this.detailsForm = form} />}
                        {navBarActiveIndex === CONST.PAYMENT_NAV_INDEX && <PaymentForm forwardedRef={(form) => this.paymentForm = form} />}
                        {navBarActiveIndex === CONST.CONFIRMATION_NAV_INDEX && <ConfirmationForm />}
                    </div>}

                    <Alert isSticky variant={alertMsg.status} isOpen={alertMsg.isOpen} onClose={() => {this.props.setAlertMessage(false);}}>{alertMsg.text}</Alert>

                    {this.props.cartId && <ShoppingCart onDetailsSubmit={this.handleDetailsSubmit} onPaymentSubmit={this.handlePaymentSubmit} history={this.props.history} />}
                    
                    {navBarActiveIndex !== CONST.CONFIRMATION_NAV_INDEX && <div className="aui-small pt-3 pb-5">Audi Australia, a division of Volkswagen Group Australia Pty Ltd, will collect, hold and use your personal information for the purpose(s) set out above. Audi may disclose your personal information to Dealers, related companies or third parties that provide us with services, including to overseas locations (such as Germany). If you consent, Audi and Audi Dealers may also use your personal information to send you communications concerning products, offers, news and events. Please note that Audi and Audi Dealers are separate organisations, and that Dealers will handle your information in accordance with their own privacy policies. Our Privacy Policy explains how you can request access to and the correction of your personal information and how you may make a privacy complaint to us. For full details, see our <a href="http://www.audi.com.au/privacypolicy" target="_blank" rel="noopener noreferrer" className="aui-textlink">Privacy Policy</a>.</div>}

                </div>}
            </div>
            </Layout>
        );
    }
}

ShoppingCartPage.propTypes = {
    navBarActiveIndex: PropTypes.number,
    updateNavBarIndex: PropTypes.func,
    setAlertMessage: PropTypes.func,
    disableNav: PropTypes.array,
    alertMsg: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartPage);
